import UploadComponent from '@components/UploadComponent';
import I18n from '@src/i18n';
import React from 'react';

interface ISampleVideoComponentPropsType {
  url?: string;
  onChange: Function;
  handleUpdateSortableListKey?: Function;
}

interface ISampleVideoComponentStateType {
  modelValidator: string;
  imageFileList: any[];
  imageUpload: any;
  modelValidatorType: boolean | null;
  fileList: any;
  isLoadingFile: boolean;
};


export default class SampleVideoComponentProcess extends React.Component<ISampleVideoComponentPropsType, ISampleVideoComponentStateType> {

  constructor(props: ISampleVideoComponentPropsType) {
    super(props);
    this.onModalImageChanged = this.onModalImageChanged.bind(this);
    this.setImageValidator = this.setImageValidator.bind(this);
    this.formatImageList = this.formatImageList.bind(this);
    this.state = {
      modelValidator: '',
      imageFileList: [],
      imageUpload: this.props.url || '',
      modelValidatorType: null,
      fileList: '',
      isLoadingFile: false
    };
  }

  componentWillMount() {
    this.initialData()  
  }

  initialData = async () => {
    await this.formatImageList();
    this.setState({ imageUpload: this.props.url !== undefined ? this.props.url : '' })
  }

  //#region HANDLERS

  setImageValidator(modelValidator: Function) {
    // this.setState({ modelValidator })
  }

  isLoadingFile = async (isLoading: any) => {
    this.setState({ isLoadingFile: isLoading })
  }
  onModalImageChanged = async (imageData: any) => {
    this.setState({ imageUpload: imageData });
    this.props.onChange(imageData)
  }
  validateType = async (validateExtension: any) => {
    this.setState({ modelValidatorType: validateExtension })
  }
  validateUploadModel = async (fileList: any) => {
    this.setState({ fileList })
  }

  formatImageList = async () => {
    let modelList: any[] = [];

    if (this.props.url !== '' && this.props.url !== undefined) {
      modelList.push({
        uid: '1',
        name: I18n.l('formflow.components.download') /*product.name || 'image.jpg'*/,
        url: this.props.url,
        thumbUrl: this.props.url,
        status: 'done'
      });
      await this.setState({ imageFileList: modelList })
    }

  }
  onRemoveModalImage = async () => {
    await this.setState({ imageUpload: '' })
    this.props.onChange(this.state.imageUpload)

  }
  //#endregion

  render() {
    return (
      <div>
        <div>
          <UploadComponent
            accept={'.mp4'}
            isStorage={true}
            onValidate={this.setImageValidator}
            buttonTitle={I18n.l('form.labels.alerts.image')}
            customListType={'picture'}
            defaultFileList={this.state.imageFileList}
            onFileListChange={this.onModalImageChanged}
            onRemoveImage={this.onRemoveModalImage}
            validateUpload={this.validateUploadModel}
            isLoadingFile={this.isLoadingFile}
            formatImageList={this.formatImageList}
            handleUpdateSortableListKey={this.props.handleUpdateSortableListKey}
          />
        </div>
        {(this.state.imageUpload === '' && !this.state.isLoadingFile) &&
          <div style={{ color: 'red', marginBottom: '10px', fontWeight: 'bold' }}>
            <span >{I18n.l('label.videoValidation')}</span>
          </div>
        }
      </div>
    );
  }
}

//#region CSS

//#endregion
